import React, { Component } from 'react';
import { 
  Row, 
  Col, 
  Form, 
} from 'react-bootstrap';

class MyLocation extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      displayLocation: '',
      error: ''
    };
  };

  componentDidMount = async () => {
    const currLocation = this.props.profile.getDefaultProfile().myLocation;
    this.setState({
      displayLocation: currLocation || ''
    })
  }

  onBlur = event => {
    event.preventDefault();
    const { displayLocation } = this.state;
   
    this.props.profile.getDefaultProfile().myLocation = displayLocation;
    this.props.profile.save();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    return (
      <Form.Group>
        <Row className='text-left'>
          <Col>
            <Form.Label>My Location</Form.Label> 
            <Form.Control
              name='displayLocation'
              value={this.state.displayLocation}
              onBlur={this.onBlur}
              onChange={this.onChange}
              type='text'
              maxLength= {20}
              placeholder="max 20 characters"
              
            />
        
     
          </Col>
        </Row>
      </Form.Group>
     )
  }
};

export default MyLocation;